import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { MatButton } from "@angular/material/button";
import { NgForOf, NgIf } from "@angular/common";
import { environment } from '@enviroment/environment';
import { decryptData } from "@shared/utils/decrypt";
import Swal from 'sweetalert2';
import {MatDivider} from "@angular/material/divider";
import {MatIcon} from "@angular/material/icon";
import {openBlankWindow} from "@shared/utils/window.utils";

@Component({
  selector: 'app-medicamento-documents-modal',
  templateUrl: './medicamento-documents-modal.component.html',
  styleUrls: ['./medicamento-documents-modal.component.scss'],
  standalone: true,
  imports: [
    MatDialogActions,
    MatButton,
    NgForOf,
    NgIf,
    MatDialogContent,
    MatDialogTitle,
    MatDivider,
    MatIcon
  ]
})
export class MedicamentoDocumentsModalComponent {
  documents: any[] = [];
  environment = environment;
  alertTypes: any[] = [];
  loadingDocs = true;
  loadingAlerts = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { medicamentoId: number, medicamentoType: string },
    public dialogRef: MatDialogRef<MedicamentoDocumentsModalComponent>,
    private http: HttpClient
  ) {
    this.fetchDocuments();
  }

  fetchDocuments() {
    this.loadingDocs = true;
    this.http.post<any>(`${environment.backend_url}VIDAL_Tools/documentos`, {
      medicamentoId: this.data.medicamentoId,
      medicamentoType: this.data.medicamentoType
    }).subscribe({
      next: (res) => {
        this.documents = res.data || [];
        this.loadingDocs = false;
      },
      error: () => {
        this.documents = [];
        this.loadingDocs = false;
      }
    });
  }

  openDocument(doc: any) {
    this.loadingDocs = true;
    this.http.post(
      `${environment.backend_url}VIDAL_Tools/fichaHtml`,
      JSON.stringify({ path: doc.url}),
      {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }
    ).subscribe({
      next: (response: any) => {
        this.loadingDocs = false;
        const encryptedHtml = response.data;
        const html = decryptData(encryptedHtml, environment.encryptionKey);
        const w = openBlankWindow();
        if (w) {
          w.document.open();
          w.document.write(html);
          w.document.close();
        } else {
          Swal.fire('Error', 'No se pudo abrir la nueva pestaña. Permite popups para este sitio.', 'error').then();
        }
      },
      error: (err) => {
        this.loadingDocs = false;
        Swal.fire('Error', 'No se pudo obtener el documento: ' + (err?.error || JSON.stringify(err)), 'error').then();
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
